import { render } from "./cardpost.vue?vue&type=template&id=2f8073b6"
import script from "./cardpost.vue?vue&type=script&lang=js"
export * from "./cardpost.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__